
import { Badge } from "@/components/ui/badge";
import { TableCell, TableRow } from "@/components/ui/table";
import { Checkbox } from "@/components/ui/checkbox";
import { AppIcon } from "./AppIcon";
import { AppCategoryBadge, AppTagBadge } from "./AppBadge";
import { App } from "@/types/app";

interface AppTableRowProps {
  app: App;
  onClick: (app: App) => void;
  showSelect?: boolean;
  isSelected?: boolean;
  onSelect?: (checked: boolean) => void;
}

export const AppTableRow = ({ 
  app, 
  onClick, 
  showSelect = false, 
  isSelected = false, 
  onSelect 
}: AppTableRowProps) => {
  const handleRowClick = (e: React.MouseEvent) => {
    // Don't trigger row click when clicking on checkbox
    if ((e.target as HTMLElement).closest('[role="checkbox"]')) {
      return;
    }
    onClick(app);
  };

  const handleCheckboxChange = (checked: boolean) => {
    onSelect?.(checked);
  };

  const getAppType = () => {
    if (app.system_app) {
      return "System";
    } else {
      return "App Store";
    }
  };

  return (
    <TableRow 
      className="cursor-pointer hover:bg-muted/50"
      onClick={handleRowClick}
    >
      {showSelect && (
        <TableCell className="w-12 py-3 px-4" onClick={(e) => e.stopPropagation()}>
          <Checkbox
            checked={isSelected}
            onCheckedChange={handleCheckboxChange}
          />
        </TableCell>
      )}
      <TableCell className="w-20 py-3 px-4">
        <AppIcon app_icon_url={app.app_icon_url} app_name={app.app_name} />
      </TableCell>
      <TableCell className="w-80 py-3 px-4 pl-8">
        <div className="truncate">
          <span className="text-sm font-medium">{app.app_name}</span>
          <div className="text-xs text-muted-foreground sm:hidden truncate">
            {app.category} • {getAppType()}
          </div>
        </div>
      </TableCell>
      <TableCell className="w-48 py-3 px-4 hidden sm:table-cell">
        <span className="text-sm text-muted-foreground">{app.category}</span>
      </TableCell>
      <TableCell className="w-32 py-3 px-4 hidden lg:table-cell">
        <span className={`text-sm ${
          app.system_app 
            ? "text-blue-600"
            : "text-green-600"
        }`}>
          {getAppType()}
        </span>
      </TableCell>
    </TableRow>
  );
};
